import React from 'react';
import {translate} from 'react-i18next';

class TagChooser extends React.PureComponent {

    constructor(props) {

        super(props);

        this.handleTagAdd = this.handleTagAdd.bind(this);
        this.handleTagRemove = this.handleTagRemove.bind(this);
    }

    handleTagAdd(tag) {

        if (this.props.onTagsAdd)
            this.props.onTagsAdd(this.parse(tag));
    }

    handleTagRemove(tag) {

        if (this.props.onTagRemove)
            this.props.onTagRemove(tag);
    }

    parse(tag) {

        return (tag.match(/[a-z0-9\-._,]/ig) || []).join('').split(',').filter(tag => tag !== '');
    }

    render() {

        const {t} = this.props;

        return (

            <div className={`tag-chooser ${this.props.className || ''}`}>
                {this.props.tags.length > 0 && (

                    <div className="tags mb-2">
                        {this.props.tags.map(tag => (

                            <div key={tag} tabIndex="0" className="tag badge badge-primary pl-2 py-2">
                                <span>#{tag}</span>
                                <a tabIndex="0" className="text-primary p-2" onClick={() => this.handleTagRemove(tag)}>
                                    <i className="fas fa-times"/>
                                </a>
                            </div>
                        ))}
                    </div>
                )}
                <div className="input-group">
                    <input ref={this.props.forwardedRef} type="text" className="form-control" placeholder={t('tagChooser.placeholder')} onKeyUp={(e) => {

                        if (e.keyCode === 13) { // Enter

                            e.preventDefault();

                            this.handleTagAdd(e.target.value);
                            e.target.value = '';
                        }
                    }}/>
                    <div className="input-group-append">
                        <button type="button" className="btn btn-primary" onClick={(e) => {

                            const input = e.currentTarget.parentNode.previousSibling;

                            this.handleTagAdd(input.value);
                            input.value = '';
                        }}>
                            <i className="fas fa-plus"/>
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

const TranslatedTagChooser = translate()(TagChooser);

export default React.forwardRef((props, ref) => {

    return <TranslatedTagChooser forwardedRef={ref} {...props}/>;
});



// WEBPACK FOOTER //
// ./src/components/TagChooser.js